import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import { useState } from "react";

import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import { PaymentType } from "@/interfaces/payment-type.interface";
import { PaymentTypeMessages } from "@/messages/platforms/talk2PayHome/payment-type.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: PaymentTypeMessages;
  selected: PaymentType;
  onRemove: (item: PaymentType) => void;
  onEdit: (item: PaymentType) => void;
}

function PaymentTypePopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selected,
  onRemove,
  onEdit,
}: Props) {
  const [isDialogOpen, setDialogOpen] = useState(false);

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<EditIcon />}
        title={messages.editPopover}
        onClick={() => {
          onEdit(selected);
          onClose();
        }}
      />
      <NotificationItem
        icon={<DeleteIcon />}
        title={messages.removePopover}
        onClick={() => setDialogOpen(true)}
      />

      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        onConfirm={() => {
          onRemove(selected);
          setDialogOpen(false);
          onClose();
        }}
        titleText={messages.deleteDialogTitle}
        descriptionText={messages.deleteDialogContent}
        cancelText={messages.deleteDialogCancel}
        confirmText={messages.deleteDialogConfirm}
        isLoading={false}
      />
    </Menu>
  );
}

export default PaymentTypePopover;
